var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.95 21.3061C17.9205 21.3061 21.95 17.2767 21.95 12.3061C21.95 7.33553 17.9205 3.30609 12.95 3.30609C7.97939 3.30609 3.94995 7.33553 3.94995 12.3061C3.94995 17.2767 7.97939 21.3061 12.95 21.3061ZM23.95 12.3061C23.95 18.3812 19.0251 23.3061 12.95 23.3061C6.87482 23.3061 1.94995 18.3812 1.94995 12.3061C1.94995 6.23096 6.87482 1.30609 12.95 1.30609C19.0251 1.30609 23.95 6.23096 23.95 12.3061Z",
    fill: "#0B907B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2428 16.0132C11.6334 16.4037 12.2665 16.4037 12.6571 16.0132L15.6571 13.0132C16.0476 12.6227 16.0476 11.9895 15.6571 11.599L12.6571 8.59898C12.2665 8.20846 11.6334 8.20846 11.2428 8.59898C10.8523 8.98951 10.8523 9.62267 11.2428 10.0132L13.5357 12.3061L11.2428 14.599C10.8523 14.9895 10.8523 15.6227 11.2428 16.0132Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleIc);
export default __webpack_public_path__ + "static/media/arrow_circle_ic.352dfcf80ef41a745d08c01c089085b2.svg";
export { ForwardRef as ReactComponent };